import "./App.css";
import Public from "./Public interface/Public";

function App() {
  return (
    <div>
      <Public />
    </div>
  );
}

export default App;
